// Dedicated capability HTTP client for the anonymous review-invitation page. Deliberately
// independent from `@infrastructure/api/axios` — that instance attaches a Firebase
// `Authorization` header whenever a session exists, and the backend rejects requests presenting
// both authority methods. This client never carries credentials and only ever sends
// `X-Access-Grant`. Mirrors `src/domains/booking-widget/services/capability-client.service.ts`,
// duplicated here (rather than imported) to keep the reviews domain self-contained.
export class ReviewInvitationRequestError extends Error {
    status;
    body;
    constructor(status, body) {
        super(`Review invitation request failed with ${status}`);
        this.status = status;
        this.body = body;
        this.name = "ReviewInvitationRequestError";
    }
}
async function request(input) {
    const baseUrl = process.env.VUE_APP_API_URL || "";
    const response = await fetch(`${baseUrl}${input.path}`, {
        method: input.method ?? "GET",
        credentials: "omit",
        headers: {
            Accept: "application/json",
            ...(input.body === undefined ? {} : { "Content-Type": "application/json" }),
            "X-Access-Grant": input.accessGrant,
        },
        body: input.body === undefined ? undefined : JSON.stringify(input.body),
    });
    const responseBody = await response.json().catch(() => null);
    if (!response.ok) {
        throw new ReviewInvitationRequestError(response.status, responseBody);
    }
    if (responseBody && typeof responseBody === "object" && "data" in responseBody) {
        return responseBody.data;
    }
    return responseBody;
}
export const reviewInvitationClientService = { request };
export default reviewInvitationClientService;
